module.exports = __webpack_public_path__ + "img/11_98.24a84ffe.png";